import { render, staticRenderFns } from "./tribune.vue?vue&type=template&id=120094c1&scoped=true&"
import script from "./tribune.vue?vue&type=script&lang=js&"
export * from "./tribune.vue?vue&type=script&lang=js&"
import style0 from "./tribune.vue?vue&type=style&index=0&id=120094c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120094c1",
  null
  
)

export default component.exports